import { Api } from './axios-config';

export interface ICampaignView {
  id: number;
  businessId: number;
  title: string;
  message: string;
  status: number;
  statusLabel: string;
  recipientCount: number;
  sentCount: number;
  createdAt: string;
  scheduledAt?: string;
  sentAt?: string;
}

export interface ICampaignRecipientView {
  id: number;
  businessClientId: number;
  clientName: string;
  phone: string;
  status: number;
  statusLabel: string;
  sentAt?: string;
  errorMessage?: string;
}

export interface ICampaignDetailView extends ICampaignView {
  recipients: ICampaignRecipientView[];
}

export interface ICreateCampaign {
  title: string;
  message: string;
  clientIds: number[];
  scheduledAt?: string;
}

const create = async (businessId: number, body: ICreateCampaign): Promise<ICampaignView> => {
  const { data } = await Api.post<{ data: ICampaignView }>(`/api/business/${businessId}/campaigns`, body);
  return data.data!;
};

const getAll = async (businessId: number): Promise<ICampaignView[]> => {
  const { data } = await Api.get<{ data: ICampaignView[] }>(`/api/business/${businessId}/campaigns`);
  return data.data ?? [];
};

const getById = async (businessId: number, campaignId: number): Promise<ICampaignDetailView> => {
  const { data } = await Api.get<{ data: ICampaignDetailView }>(`/api/business/${businessId}/campaigns/${campaignId}`);
  return data.data!;
};

const send = async (businessId: number, campaignId: number): Promise<void> => {
  await Api.post(`/api/business/${businessId}/campaigns/${campaignId}/send`);
};

const cancel = async (businessId: number, campaignId: number): Promise<void> => {
  await Api.delete(`/api/business/${businessId}/campaigns/${campaignId}`);
};

export const campaignService = {
  create,
  getAll,
  getById,
  send,
  cancel,
};
